import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const InformeTrimestralService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Informe/InformeTrimestral",
            values, customConfig
        );
        return resultado;
    } catch (error) {
        console.log(error);
    }
}

export { InformeTrimestralService };
